import script from "./ConfirmJurisdictionModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConfirmJurisdictionModal.vue?vue&type=script&lang=ts&setup=true"

import "./ConfirmJurisdictionModal.vue?vue&type=style&index=0&id=0fd09557&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fd09557"]])

export default __exports__